import React from "react";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import LazyFlagProvider from "context-providers/lazyfeatureflag.provider";
import ReactDOM from "react-dom";
import RootContainer from "./root-container";
import AuthenticatorContainer from "./authenticator-container";
import ErrorBoundaryContainer from "./error-boundary-container";
import SignIn from "../components/auth/SignIn";
import Auth from "../components/auth/Auth";
import AppWindow from "../helpers/app-window";

if (process.env.NODE_ENV !== "production") {
  const axe = require("@axe-core/react");
  const axeConf = {
    runOnly: {
      type: "tag",
      values: ["wcag21aa"]
    }
  };
  axe(React, ReactDOM, 1000, axeConf);
}

export default function AuthContainer() {
  const appWindow = AppWindow() as any;
  return (
    <ErrorBoundaryContainer>
      <LazyFlagProvider tag="mpng-student">
        <Router>
          <Routes>
            <Route path="/landing" element={<SignIn />} />
            <Route path="/auth" element={<Auth />} />
            <Route
              path="/*"
              element={
                <AuthenticatorContainer>
                  <RootContainer />
                </AuthenticatorContainer>
              }
            />
          </Routes>
        </Router>
      </LazyFlagProvider>
    </ErrorBoundaryContainer>
  );
}
